import CampusConsultorioDashboard from "./campus-consultorio";

export default function CampusDashboard() {
  return <CampusConsultorioDashboard moduleFocus="campus" />;
}

